if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });

      this.productWrapper = this.closest('.thb-product-detail');
      this.productSlider = this.productWrapper.querySelector('.product-images');
      this.hideVariants = this.dataset.hideVariants === 'true';
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
        //this.updateShareUrl();
      }

      this.updateOther();
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
        } else if (fieldset.querySelectorAll('input').length) {
          this.options.push(fieldset.querySelector('input:checked').value);
        }
      });
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value='${option}']`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      let productSlider = document.querySelector('.thb-product-detail .product-images'),
        thumbnails = document.querySelector('.thb-product-detail #Product-Thumbnails');

      this.setActiveMedia(`#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`, `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`, productSlider, thumbnails);
    }
    setActiveMedia(mediaId, thumbId, productSlider, thumbnails) {
      let isInit = productSlider.classList.contains('slider-initialized') || (typeof Flickity !== 'undefined' && Flickity.data(productSlider)),
        activeMedia = productSlider.querySelector(mediaId);

      if (isInit && this.hideVariants) {


        if (productSlider.querySelector('.product-images__slide.is-initial-selected')) {
          productSlider.querySelector('.product-images__slide.is-initial-selected').classList.remove('is-initial-selected');
        }
        [].forEach.call(productSlider.querySelectorAll('.product-images__slide-item--variant'), function (el) {
          el.classList.remove('is-active');
        });

        activeMedia.classList.add('is-active');
        activeMedia.classList.add('is-initial-selected');

        this.setImageSetMedia();

        if (thumbnails) {
          let activeThumb = thumbnails.querySelector(thumbId);

          if (thumbnails.querySelector('.product-thumbnail.is-initial-selected')) {
            thumbnails.querySelector('.product-thumbnail.is-initial-selected').classList.remove('is-initial-selected');
          }
          [].forEach.call(thumbnails.querySelectorAll('.product-images__slide-item--variant'), function (el) {
            el.classList.remove('is-active');
          });

          activeThumb.classList.add('is-active');
          activeThumb.classList.add('is-initial-selected');
        }

        productSlider.reInit(this.imageSetIndex);
        productSlider.selectCell(mediaId);

      } else if (isInit) {
        productSlider.selectCell(mediaId);
      }

    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`];
    }

    renderProductInfo() {
      let sections = this.getSectionsToRender();

      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + '--sticky');

            if (price) price.classList.remove('visibility-hidden');
            if (price_fixed) price_fixed.classList.remove('visibility-hidden');

          });
          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);

        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      if (!submitButtons) return;

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          if (text) submitButtonText.textContent = text;
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');
          submitButtonText.textContent = window.theme.variantStrings.addToCart;
        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButtonText) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') {
        return;
      }
      const variant_data = this.getVariantData();


      if (variant_data) {

        const selected_options = this.currentVariant.options.map((value, index) => {
          return {
            value,
            index: `option${index + 1}`
          };
        });
        const available_options = this.createAvailableOptionsTree(variant_data, selected_options);


        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector('select')) {
              fieldset_options.forEach((option, option_i) => {
                if (option.isUnavailable) {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = true;
                } else {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = false;
                }
              });
            } else if (fieldset.querySelectorAll('input').length) {
              fieldset.querySelectorAll('input').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        });

      }
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;
        this.setImageSetMedia();
      }
    }
    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }

      let setValue = this.getImageSetName(this.currentVariant[this.imageSetIndex]);
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productWrapper.querySelectorAll(`.product-images__slide[data-set-name="${this.imageSetName}"]`),
        selected_set_thumbs = this.productWrapper.querySelectorAll(`.product-thumbnail[data-set-name="${this.imageSetName}"]`);

      if (this.hideVariants) {
        // Product images
        this.productWrapper.querySelectorAll('.product-images__slide').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_images.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });

        // Product thumbnails
        this.productWrapper.querySelectorAll('.product-thumbnail').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_thumbs.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });
      }

    }

    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // Make sure if a variant is unavailable, disable currently selected option
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}

if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   *
   *  Supports two modes:
   *  1. CSS scroll-snap (when data-scroll-snap="true") — no Flickity dependency
   *  2. Flickity (default) — legacy behavior for templates that haven't migrated
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', this.setupProductGallery);
    }
    connectedCallback() {
      this.product_container = this.closest('.thb-product-detail');
      this.thumbnail_container = this.product_container.querySelector('.product-thumbnail-container');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');
      this.useScrollSnap = this.dataset.scrollSnap === 'true';

      this.setOptions();

      if (this.useScrollSnap) {
        this.initScrollSnap();
      } else {
        this.init();
      }
    }

    // ================================================================
    //  SHARED SETUP
    // ================================================================

    setOptions() {
      this.hide_variants = this.dataset.hideVariants == 'true';
      this.thumbnails = this.thumbnail_container.querySelectorAll('.product-thumbnail');
      this.prev_button = this.querySelector('.flickity-prev');
      this.next_button = this.querySelector('.flickity-next');

      if (!this.useScrollSnap) {
        this.options = {
          wrapAround: true,
          pageDots: true,
          contain: true,
          adaptiveHeight: true,
          initialIndex: '.is-initial-selected',
          prevNextButtons: false,
          fade: false,
          cellSelector: '.product-images__slide.is-active'
        };
      }
    }

    // ================================================================
    //  SCROLL-SNAP MODE
    // ================================================================

    initScrollSnap() {
      // Apply scroll container styles
      this.style.display = 'flex';
      this.style.overflowX = 'auto';
      this.style.scrollSnapType = 'x mandatory';
      this.style.scrollBehavior = 'smooth';
      this.style.scrollbarWidth = 'none';

      this.classList.add('slider-initialized');

      // Mark parent for CSS targeting of moved arrows/dots
      const imageContainer = this.closest('.product-image-container');
      if (imageContainer) imageContainer.classList.add('slider-parent');

      this._activeSlides = Array.from(this.querySelectorAll('.product-images__slide.is-active'));

      // Apply slide styles
      this._activeSlides.forEach(slide => {
        slide.style.flex = '0 0 100%';
        slide.style.scrollSnapAlign = 'center';
      });

      this.selectedIndex = 0;

      // Find initial selected slide
      const initialSlide = this.querySelector('.product-images__slide.is-active.is-initial-selected');
      if (initialSlide) {
        const idx = this._activeSlides.indexOf(initialSlide);
        if (idx > 0) {
          this.selectedIndex = idx;
          // Scroll to initial without animation
          requestAnimationFrame(() => {
            this.scrollLeft = initialSlide.offsetLeft;
          });
        }
      }

      // Setup IntersectionObserver for slide tracking
      this._setupObserver();

      // Build dots (mobile)
      this._buildDots();

      // Setup nav arrows
      this._setupScrollSnapEvents();

      // Start Gallery (PhotoSwipe)
      this.setupProductGallery();
    }

    _setupObserver() {
      if (this._observer) {
        this._observer.disconnect();
      }
      this._observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
            const newIndex = this._activeSlides.indexOf(entry.target);
            if (newIndex !== -1 && newIndex !== this.selectedIndex) {
              const prevIndex = this.selectedIndex;
              this.selectedIndex = newIndex;
              this._onSlideChange(prevIndex, newIndex);
            }
          }
        });
      }, {
        root: this,
        threshold: 0.5
      });

      this._activeSlides.forEach(slide => {
        this._observer.observe(slide);
      });
    }

    _onSlideChange(prevIndex, newIndex) {
      // Sync thumbnails
      const active_thumbs = Array.from(this.thumbnails).filter(el => el.classList.contains('is-active'));
      const active_thumb = active_thumbs[newIndex] || active_thumbs[0];

      if (active_thumb) {
        this.thumbnails.forEach(item => item.classList.remove('is-initial-selected'));
        active_thumb.classList.add('is-initial-selected');

        requestAnimationFrame(() => {
          if (active_thumb.offsetParent === null) return;
          const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
            windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
          active_thumb.parentElement.scrollTo({
            left: active_thumb.offsetLeft - windowHalfWidth + active_thumb.clientWidth / 2,
            top: active_thumb.offsetTop - windowHalfHeight + active_thumb.clientHeight / 2,
            behavior: 'smooth'
          });
        });
      }

      // Update dots
      this._updateDots(newIndex);

      // Stop previous video
      if (prevIndex >= 0 && prevIndex < this._activeSlides.length) {
        const previous_slide = this._activeSlides[prevIndex];
        const previous_media = previous_slide.querySelector('.product-single__media');
        if (previous_media) {
          if (previous_media.classList.contains('product-single__media-external-video')) {
            if (previous_media.dataset.provider === 'youtube') {
              previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
                event: "command",
                func: "pauseVideo",
                args: ""
              }), "*");
            } else if (previous_media.dataset.provider === 'vimeo') {
              previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
                method: "pause"
              }), "*");
            }
            previous_media.querySelector('.product-single__media-external-video--play').removeAttribute('hidden');
          } else if (previous_media.classList.contains('product-single__media-native-video')) {
            previous_media.querySelector('video').pause();
          }
        }
      }
    }

    _buildDots() {
      // Place dots in parent .product-image-container (outside the scroll container)
      const imageContainer = this.closest('.product-image-container');
      const existingDots = imageContainer ? imageContainer.querySelector('.slider-dots') : this.querySelector('.slider-dots');
      if (existingDots) existingDots.remove();

      if (this._activeSlides.length <= 1) return;

      const dotsContainer = document.createElement('div');
      dotsContainer.className = 'slider-dots';

      this._activeSlides.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.className = 'slider-dot' + (i === this.selectedIndex ? ' is-selected' : '');
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Slide ' + (i + 1));
        dot.addEventListener('click', () => this.select(i));
        dotsContainer.appendChild(dot);
      });

      if (imageContainer) {
        imageContainer.appendChild(dotsContainer);
      } else {
        this.parentElement.appendChild(dotsContainer);
      }
    }

    _updateDots(index) {
      const imageContainer = this.closest('.product-image-container') || this.parentElement;
      const dots = imageContainer.querySelectorAll('.slider-dot');
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-selected', i === index);
      });
    }

    _setupScrollSnapEvents() {
      // Move nav arrows outside the scroll container so they don't scroll
      const imageContainer = this.closest('.product-image-container');

      if (this.prev_button) {
        let prev = this.prev_button.cloneNode(true);
        this.prev_button.remove();
        this.prev_button = prev;
        if (imageContainer) {
          imageContainer.appendChild(prev);
        } else {
          this.parentElement.appendChild(prev);
        }
        prev.addEventListener('click', () => {
          const newIndex = this.selectedIndex <= 0 ? this._activeSlides.length - 1 : this.selectedIndex - 1;
          this.select(newIndex);
        });
        prev.addEventListener('keyup', (e) => {
          const newIndex = this.selectedIndex <= 0 ? this._activeSlides.length - 1 : this.selectedIndex - 1;
          this.select(newIndex);
          e.preventDefault();
        });
      }
      if (this.next_button) {
        let next = this.next_button.cloneNode(true);
        this.next_button.remove();
        this.next_button = next;
        if (imageContainer) {
          imageContainer.appendChild(next);
        } else {
          this.parentElement.appendChild(next);
        }
        next.addEventListener('click', () => {
          const newIndex = this.selectedIndex >= this._activeSlides.length - 1 ? 0 : this.selectedIndex + 1;
          this.select(newIndex);
        });
        next.addEventListener('keyup', (e) => {
          const newIndex = this.selectedIndex >= this._activeSlides.length - 1 ? 0 : this.selectedIndex + 1;
          this.select(newIndex);
          e.preventDefault();
        });
      }

      // Video play buttons
      this.video_containers.forEach((container) => {
        container.querySelector('button').addEventListener('click', function () {
          container.setAttribute('hidden', '');
        });
      });

      // Thumbnail clicks
      setTimeout(() => {
        let active_thumbs = Array.from(this.thumbnails).filter(el => el.clientWidth > 0);
        active_thumbs.forEach((thumbnail, index) => {
          thumbnail.addEventListener('click', () => {
            this.thumbnailClick(thumbnail, index);
          });
        });
      });
    }

    select(index) {
      if (index < 0 || index >= this._activeSlides.length) return;
      const slide = this._activeSlides[index];
      this.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    }

    selectCell(mediaId) {
      if (this.useScrollSnap) {
        const slide = this.querySelector(mediaId);
        if (!slide) return;
        const idx = this._activeSlides.indexOf(slide);
        if (idx !== -1) {
          this.select(idx);
        } else {
          // Slide may not be in _activeSlides yet (e.g. after reInit)
          this.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        }
      } else {
        this.flkty.selectCell(mediaId);
      }
    }

    reInit(imageSetIndex) {
      if (this.useScrollSnap) {
        // Re-query active slides, rebuild observer and dots
        if (this._observer) this._observer.disconnect();

        this._activeSlides = Array.from(this.querySelectorAll('.product-images__slide.is-active'));
        this._activeSlides.forEach(slide => {
          slide.style.flex = '0 0 100%';
          slide.style.scrollSnapAlign = 'center';
        });

        this.selectedIndex = 0;

        // Find initial selected slide
        const initialSlide = this.querySelector('.product-images__slide.is-active.is-initial-selected');
        if (initialSlide) {
          const idx = this._activeSlides.indexOf(initialSlide);
          if (idx >= 0) {
            this.selectedIndex = idx;
            this.scrollLeft = initialSlide.offsetLeft;
          }
        }

        this._setupObserver();
        this._buildDots();
      } else {
        this.flkty.destroy();
        this.setOptions();
        this.flkty = new Flickity(this, this.options);
        this.setupEvents();
        this.selectedIndex = this.flkty.selectedIndex;
      }
    }

    resize() {
      // No-op for scroll-snap mode (CSS handles layout).
      // For Flickity mode, delegate to Flickity.
      if (!this.useScrollSnap && this.flkty) {
        this.flkty.resize();
      }
    }

    setDraggable(draggable) {
      if (this.useScrollSnap) {
        // No-op — native scroll handles touch/drag
        return;
      }
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }

    // ================================================================
    //  FLICKITY MODE (legacy)
    // ================================================================

    init() {
      this.flkty = new Flickity(this, this.options);

      this.selectedIndex = this.flkty.selectedIndex;

      // Setup Events
      this.setupEvents();

      // Start Gallery
      this.setupProductGallery();
    }

    setupEvents() {
      const _this = this;
      if (this.prev_button) {
        let prev = this.prev_button.cloneNode(true);
        this.prev_button.parentNode.append(prev);
        this.prev_button.remove();
        prev.addEventListener('click', (event) => {
          this.flkty.previous();
        });
        prev.addEventListener('keyup', (event) => {
          this.flkty.previous();
          event.preventDefault();
        });
      }
      if (this.next_button) {
        let next = this.next_button.cloneNode(true);
        this.next_button.parentNode.append(next);
        this.next_button.remove();
        next.addEventListener('click', (event) => {
          this.flkty.next();
        });
        next.addEventListener('keyup', (event) => {
          this.flkty.next();
          event.preventDefault();
        });
      }
      this.video_containers.forEach((container) => {
        container.querySelector('button').addEventListener('click', function () {
          container.setAttribute('hidden', '');
        });
      });
      this.flkty.on('settle', function (index) {
        _this.selectedIndex = index;
      });
      this.flkty.on('change', (index) => {

        let previous_slide = this.flkty.cells[_this.selectedIndex].element,
          previous_media = previous_slide.querySelector('.product-single__media'),
          active_thumbs = Array.from(this.thumbnails).filter(element => element.classList.contains('is-active')),
          active_thumb = active_thumbs[index] ? active_thumbs[index] : active_thumbs[0];

        this.thumbnails.forEach((item, i) => {
          item.classList.remove('is-initial-selected');
        });
        active_thumb.classList.add('is-initial-selected');

        requestAnimationFrame(() => {
          if (active_thumb.offsetParent === null) {
            return;
          }
          const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
            windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
          active_thumb.parentElement.scrollTo({
            left: active_thumb.offsetLeft - windowHalfWidth + active_thumb.clientWidth / 2,
            top: active_thumb.offsetTop - windowHalfHeight + active_thumb.clientHeight / 2,
            behavior: 'smooth'
          });
        });

        // Stop previous video
        if (previous_media.classList.contains('product-single__media-external-video')) {
          if (previous_media.dataset.provider === 'youtube') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              event: "command",
              func: "pauseVideo",
              args: ""
            }), "*");
          } else if (previous_media.dataset.provider === 'vimeo') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              method: "pause"
            }), "*");
          }
          previous_media.querySelector('.product-single__media-external-video--play').removeAttribute('hidden');
        } else if (previous_media.classList.contains('product-single__media-native-video')) {
          previous_media.querySelector('video').pause();
        }

      });


      setTimeout(() => {
        const active_thumbs = Array.from(this.thumbnails).filter(element => element.clientWidth > 0);
        active_thumbs.forEach((thumbnail, index) => {
          // Clone and replace to remove any previously stacked listeners
          const fresh = thumbnail.cloneNode(true);
          thumbnail.parentNode.replaceChild(fresh, thumbnail);
          fresh.addEventListener('click', () => {
            this.thumbnailClick(fresh, index);
          });
        });
      });

    }

    thumbnailClick(thumbnail, index) {
      [].forEach.call(this.thumbnails, function (el) {
        el.classList.remove('is-initial-selected');
      });
      thumbnail.classList.add('is-initial-selected');
      if (this.useScrollSnap) {
        this.select(index);
      } else {
        this.flkty.select(index);
      }
    }

    // ================================================================
    //  PHOTOSWIPE (shared by both modes)
    // ================================================================

    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }
      this.setEventListeners();
    }
    buildItems() {
      this.activeImages = Array.from(this.querySelectorAll('.product-images__slide.is-active .product-single__media-image'));

      return this.activeImages.map((item) => {
        let index = [].indexOf.call(item.parentNode.parentNode.children, item.parentNode);

        let activelink = item.querySelector('.product-single__media-zoom');

        activelink.dataset.index = index;
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h
        };
      });
    }
    setEventListeners() {
      this.links = this.querySelectorAll('.product-single__media-zoom');
      this.pswpElement = document.querySelectorAll('.pswp')[0];
      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail = this.useScrollSnap
            ? this._activeSlides[this.selectedIndex]
            : this.querySelector('.product-images__slide.is-selected'),
            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      };


      this.links.forEach((link => {
        link.addEventListener('click', (e) => this.zoomClick(e, link));
      }));
    }
    zoomClick(e, link) {
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset.index, 10);
      if (typeof PhotoSwipe !== 'undefined') {
        let pswp = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, this.items, this.pswpOptions);
        pswp.listen('firstUpdate', function () {
          pswp.listen('parseVerticalMargin', function (item) {
            item.vGap = {
              top: 50,
              bottom: 50
            };
          });
        });
        pswp.init();
      }
      e.preventDefault();
    }
  }
  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.sticky = this.dataset.sticky;
      // Prefer the form inside this custom element so unique form IDs
      // (e.g. PDP Product Switcher: product-form-{section}-primary-{block})
      // are found correctly. Fall back to the legacy section-scoped lookup.
      this.form = this.querySelector('form') || document.getElementById(`product-form-${this.dataset.section}`);
      const _idInput = this.form && this.form.querySelector('[name=id]');
      if (_idInput) _idInput.disabled = false;
      if (!this.sticky) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    async onSubmitHandler(evt) {
  console.log('[Whoop] ProductForm.onSubmitHandler()');
  evt.preventDefault();

  if (this._submitting) return;
  this._submitting = true;

  if (!this.form.reportValidity()) {
    this._submitting = false;
    return;
  }

  const submitButtons = this.querySelectorAll('.single-add-to-cart-button');

  submitButtons.forEach((submitButton) => {
    if (submitButton.classList.contains('loading')) return;
    submitButton.setAttribute('aria-disabled', true);
    submitButton.classList.add('loading');
  });

  this.handleErrorMessage();

  // PDP sections (whoop products): remove old device/sub/bonus items before adding new selection
  await this._removePdpCartDuplicates();

  const config = {
    method: 'POST',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Accept': 'application/javascript'
    }
  };

  let formData = new FormData(this.form);

  // Optional upsell items (added via JSON later so selling_plan can be included reliably)
  let upsellPayload = [];

  var bundleGroupId = '';
  var bundleGroupInput = this.form.querySelector('[data-bundle-group-id-input]');
  if (bundleGroupInput) {
    bundleGroupId = Date.now().toString(36) + '-' + Math.random().toString(36).substr(2, 6);
    bundleGroupInput.value = bundleGroupId;
    formData.set('properties[_bundle_group_id]', bundleGroupId);
  }

    const freeGiftId = this.form.getAttribute('data-free-gift-id');
  
    if(freeGiftId) {
      formData.append('items[][id]', freeGiftId);
    }
       const freeGiftIdNew = this.form.getAttribute('data-free-gift-id-new');
        const freeGiftIdNew3 = this.form.getAttribute('data-free-gift-id-new3');
        const freeGiftIdNew4 = this.form.getAttribute('data-free-gift-id-new4');
    
    
    if(freeGiftIdNew) {
      formData.append('items[][id]', freeGiftIdNew);
    }
      if(freeGiftIdNew3) {
      formData.append('items[][id]', freeGiftIdNew3);
    }
      if(freeGiftIdNew4) {
      formData.append('items[][id]', freeGiftIdNew4);
    }
      
    const additionalProductId = this.form.getAttribute('data-additional-product-id');
    const additionalSellingPlan = this.form.getAttribute('data-additional-prod-selling-plan');

    const additionalProductIdNew = this.form.getAttribute('data-additional-new-product-id');
    const additionalSellingPlanNew = this.form.getAttribute('data-additional-new-prod-selling-plan');

    const upsellConfig = document.querySelector(`[data-upsell-config][data-section-id="${this.dataset.section}"]`);
    const upsellToggle = upsellConfig
      ? document.querySelector(`[data-upsell-toggle][data-section-id="${this.dataset.section}"]`)
      : null;
    const upsellEnabled = upsellConfig
      ? (upsellToggle ? upsellToggle.checked : upsellConfig.dataset.enabledDefault === 'true')
      : false;

    // Only suppress legacy "additional_product" auto-add when upsell is explicitly enabled.
    // If toggle is OFF, keep legacy additional product behavior.
    const shouldIgnoreAdditionalProducts = Boolean(upsellConfig && upsellEnabled && upsellConfig.dataset.suppressAdditional !== 'false');

    // Check if subscription variants already exist in cart to avoid duplicates
    var existingSubIds = new Set();
    if (!shouldIgnoreAdditionalProducts && (additionalProductId || additionalProductIdNew)) {
      try {
        var cartResp = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        if (cartResp.ok) {
          var cartData = await cartResp.json();
          cartData.items.forEach(function(ci) { existingSubIds.add(String(ci.variant_id)); });
        }
      } catch (e) {}
    }

    if (!shouldIgnoreAdditionalProducts) {
      if (additionalProductId && additionalSellingPlan && !existingSubIds.has(String(additionalProductId))) {
        formData.append('items[][id]', additionalProductId);
        formData.append('items[][quantity]', '1');
        formData.append('items[][selling_plan]', additionalSellingPlan);
      }

      if (additionalProductIdNew && additionalSellingPlanNew && !existingSubIds.has(String(additionalProductIdNew))) {
        formData.append('items[][id]', additionalProductIdNew);
        formData.append('items[][quantity]', '1');
        formData.append('items[][selling_plan]', additionalSellingPlanNew);
      }
    }

    if (upsellConfig && upsellEnabled) {
        let upsellItems = [];
        const itemsJson = upsellConfig.dataset.itemsJson;
        if (itemsJson) {
          try {
            const parsed = JSON.parse(itemsJson);
            if (Array.isArray(parsed)) upsellItems = parsed;
          } catch (e) {}
        }

        if (!upsellItems || upsellItems.length === 0) {
          upsellItems = (upsellConfig.dataset.items || '')
            .split(',')
            .map((item) => ({ id: item.trim() }))
            .filter((item) => item.id);
        }

        const existingVariantIds = new Set();
        const selectedVariantId = formData.get('id');

        if (selectedVariantId) existingVariantIds.add(String(selectedVariantId));
        if (freeGiftId) existingVariantIds.add(String(freeGiftId));
        if (freeGiftIdNew) existingVariantIds.add(String(freeGiftIdNew));
        if (freeGiftIdNew3) existingVariantIds.add(String(freeGiftIdNew3));
        if (freeGiftIdNew4) existingVariantIds.add(String(freeGiftIdNew4));

        const candidateUpsells = [];
        upsellItems.forEach((item) => {
          const rawId = item && item.id != null ? item.id : item;
          const normalizedVariantId = String(rawId).trim();
          if (!normalizedVariantId || existingVariantIds.has(normalizedVariantId)) return;

          const payloadItem = {
            id: Number(normalizedVariantId) || normalizedVariantId,
            quantity: 1
          };
          if (item && item.selling_plan != null && String(item.selling_plan).trim() !== '') {
            payloadItem.selling_plan = Number(item.selling_plan) || item.selling_plan;
          }

          candidateUpsells.push(payloadItem);
          existingVariantIds.add(normalizedVariantId);
        });

        if (candidateUpsells.length > 0) {
          // Avoid adding duplicates already present in the cart
          try {
            const cartResp = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
            if (cartResp.ok) {
              const cartData = await cartResp.json();
              const cartVariantIds = new Set();
              cartData.items.forEach(function(ci) { cartVariantIds.add(String(ci.variant_id)); });
              upsellPayload = candidateUpsells.filter((ci) => !cartVariantIds.has(String(ci.id)));
            } else {
              upsellPayload = candidateUpsells;
            }
          } catch (e) {
            upsellPayload = candidateUpsells;
          }
        }
    }
  


  formData.append('sections', this.getSectionsToRender().map((section) => section.section));
  formData.append('sections_url', window.location.pathname);
  config.body = formData;

  // Cart limit enforcement: group-based limit from theme settings
  const _cartLimitRaw = this.dataset.cartLimit;
  const _limitGroup = this.dataset.limitGroup;
  if (_cartLimitRaw && _limitGroup) {
    const _cartLimit = parseInt(_cartLimitRaw, 10);
    if (!isNaN(_cartLimit) && _cartLimit > 0) {
      try {
        const _cartResp = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        if (_cartResp.ok) {
          const _cartData = await _cartResp.json();
          // Build a map of productId -> limitGroup from rendered quantity-selectors
          const _groupMap = {};
          document.querySelectorAll('quantity-selector[data-product-id][data-limit-group]').forEach((qs) => {
            _groupMap[qs.dataset.productId] = qs.dataset.limitGroup;
          });
          // Sum qty of all cart items in the same limit group
          const _currentQty = _cartData.items
            .filter((ci) => (_groupMap[String(ci.product_id)] || '') === _limitGroup)
            .reduce((sum, ci) => sum + ci.quantity, 0);
          const _requestedQty = parseInt(formData.get('quantity') || '1', 10);
          if (_currentQty + _requestedQty > _cartLimit) {
            const _limitMsg = this.dataset.cartLimitText || 'Order quantity limit is reached.';
            this.handleErrorMessage(_limitMsg);
            submitButtons.forEach((btn) => { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); });
            this._submitting = false;
            return;
          }
        }
      } catch (e) {}
    }
  }

  fetch(`${theme.routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then(async (response) => {
      if (response.status) {
        dispatchCustomEvent('product:variant-error', {
          source: 'product-form',
          productVariantId: formData.get('id'),
          errors: response.description,
          message: response.message
        });
        this.handleErrorMessage(response.description);
        return;
      }
      // Add addon items (subscription add-ons) via JSON to avoid FormData parser issues
      var parentProduct = response.hasOwnProperty('items') ? response.items[0] : response;
      var addonItemsAttr = this.dataset && this.dataset.addonItems;
      console.log('[BonusItems] data-addon-items attr:', addonItemsAttr);
      if (addonItemsAttr) {
        try {
          var addonConfig = JSON.parse(addonItemsAttr);
          if (Array.isArray(addonConfig) && addonConfig.length > 0) {
            var addonPayload = [];
            for (var ai = 0; ai < addonConfig.length; ai++) {
              var addon = addonConfig[ai];
              if (!addon.variant_id) continue;
              var addonItem = {
                id: addon.variant_id,
                quantity: 1,
                properties: {
                  _pdp_addon: 'true',
                  _pdp_addon_of: String(parentProduct.product_id),
                  _plan_type: addon.plan_type || '',
                  _alt_variant_id: String(addon.alt_variant_id || ''),
                  _alt_selling_plan_id: String(addon.alt_selling_plan_id || ''),
                  _alt_product_id: String(addon.alt_product_id || ''),
                  _bundle_group_id: bundleGroupId,
                  _bundle_role: 'device',
                  _source: bundleGroupId ? 'pulsetto_bundle' : ''
                }
              };
              if (addon.selling_plan_id) {
                addonItem.selling_plan = Number(addon.selling_plan_id) || addon.selling_plan_id;
              }
              addonPayload.push(addonItem);
            }
            if (addonPayload.length > 0) {
              console.log('[BonusItems] Sending addon payload:', JSON.stringify(addonPayload));
              var addonSections = this.getSectionsToRender().map(function(s) { return s.section; }).join(',');
              var addonResp = await fetch(theme.routes.cart_add_url + '.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({
                  items: addonPayload,
                  sections: addonSections,
                  sections_url: window.location.pathname
                })
              });
              if (addonResp.ok) {
                var addonData = await addonResp.json();
                console.log('[BonusItems] Addon added successfully:', addonData);
                if (addonData.sections) {
                  response.sections = addonData.sections;
                }
              } else {
                var addonErr = {};
                try { addonErr = await addonResp.json(); } catch(e) {}
                console.log('[BonusItems] Addon add failed:', addonResp.status, addonErr);
              }
            }
          }
        } catch (e) {
          console.log('[BonusItems] Error adding addon items in form submit:', e);
        }
      }

      // Add bonus items BEFORE rendering cart drawer so they appear instantly
      console.log('[Whoop] Checking for bonus items to add');
      var bonusIncluded = false;
      var bonusItemsAttr = this.dataset && this.dataset.bonusItems;
      if (bonusItemsAttr) {
        try {
          var bonusConfig = JSON.parse(bonusItemsAttr);
          if (Array.isArray(bonusConfig) && bonusConfig.length > 0) {
            var bonusPayload = [];
            for (var i = 0; i < bonusConfig.length; i++) {
              var b = bonusConfig[i];
              if (!b.product_id || !b.variant_id) continue;
              // Skip free ($0) bonus items unless tagged checkout_visible
              if ((!b.variant_price || b.variant_price <= 0) && !b.checkout_visible) continue;
              var bonusItem = {
                id: b.variant_id,
                quantity: parentProduct.quantity || 1,
                properties: {
                  _bonus: 'true',
                  _bonus_of: String(parentProduct.product_id),
                  _bonus_parent_line: parentProduct.key || '',
                  _bonus_cfg_hash: String(b.product_id),
                  _bundle_group_id: bundleGroupId,
                  _bundle_role: 'bonus',
                  _source: bundleGroupId ? 'pulsetto_bundle' : ''
                }
              };
              if (b.selling_plan_id) bonusItem.selling_plan = Number(b.selling_plan_id);
              bonusPayload.push(bonusItem);
            }
            console.log('[Whoop] Adding bonus items:', bonusPayload);
            if (bonusPayload.length > 0) {
              bonusIncluded = true;
              var sectionNames = this.getSectionsToRender().map(function(s) { return s.section; }).join(',');
              var bonusResp = await fetch(theme.routes.cart_add_url + '.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({
                  items: bonusPayload,
                  sections: sectionNames,
                  sections_url: window.location.pathname
                })
              });
              if (bonusResp.ok) {
                var bonusData = await bonusResp.json();
                if (bonusData.sections) {
                  response.sections = bonusData.sections;
                }
              }
            }
          }
        } catch (e) {
          console.log('[BonusItems] Error adding bonus items in form submit:', e);
        }
      }

      // Add upsell items (supports subscription selling_plan)
      if (Array.isArray(upsellPayload) && upsellPayload.length > 0) {
        try {
          var sectionNames2 = this.getSectionsToRender().map(function(s) { return s.section; }).join(',');
          var upsellResp = await fetch(theme.routes.cart_add_url + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: upsellPayload,
              sections: sectionNames2,
              sections_url: window.location.pathname
            })
          });
          if (upsellResp.ok) {
            var upsellData = await upsellResp.json();
            if (upsellData.sections) {
              response.sections = upsellData.sections;
            }
          }
        } catch (e) {}
      }

      // Forms that opt in (data-cart-page-fallback) land on the cart page when
      // the layout has no cart drawer to open — stripped landing layouts.
      const addOnly = evt.submitter && evt.submitter.id !== 'BuyItNow';
      const goToCartPage = addOnly && this.hasAttribute('data-cart-page-fallback') && !document.getElementById('Cart-Drawer');

      if (addOnly && !goToCartPage) {
        this.renderContents(response);
      }

      dispatchCustomEvent('cart:item-added', {
        product: response.hasOwnProperty('items') ? response.items[0] : response,
        bonusIncluded: bonusIncluded
      });

      if (goToCartPage) {
        window.location.href = theme.routes.cart_url || '/cart';
      }
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      this._submitting = false;
      submitButtons.forEach((submitButton) => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
      });
      // Once, not per button: an Add to cart + Buy now pair shares one form.
      if (submitButtons.length && evt.submitter && evt.submitter.id === 'BuyItNow') {
        goToCheckout();
      }
    });

  const checkoutPath = "/checkout";

  // Function to navigate to the checkout page
  function goToCheckout() {
    const checkoutUrl = `${window.location.origin}${checkoutPath}`;
    window.location.href = checkoutUrl;
  }
}

    /**
     * PDP cart replacement: before adding a new device/subscription selection,
     * remove any existing PDP items (device, subscription, bonus, addon) from the cart.
     * Only runs when data-pdp-replace-ids is set (whoop PDP sections).
     */
    async _removePdpCartDuplicates() {
      console.log('[Whoop] ProductForm._removePdpCartDuplicates()');
      var attr = this.dataset.pdpReplaceIds;
      if (!attr) return;

      var idSet = attr.split(',').map(function(s) { return s.trim(); }).filter(Boolean);
      if (idSet.length === 0) return;

      try {
        var resp = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        var cart = await resp.json();

        var updates = {};
        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i];
          var pid = String(item.product_id);
          var props = item.properties || {};

          // Stepped-mode bundle items — always remove if product matches replace IDs
          if (props._source === 'pulsetto_bundle' && idSet.indexOf(pid) !== -1) {
            updates[item.key] = 0;
            continue;
          }

          // Addon item linked to a PDP product (stepped mode subscription)
          if (props._pdp_addon === 'true') {
            if (idSet.indexOf(pid) !== -1 || idSet.indexOf(String(props._pdp_addon_of)) !== -1) {
              updates[item.key] = 0;
              continue;
            }
          }

          // Device or subscription product — only remove if added via whoop PDP.
          // Whoop items have a selling plan (bundle mode) or addon children.
          // Standalone devices without these are non-whoop and should be kept.
          if (idSet.indexOf(pid) !== -1) {
            var hasSellingPlan = !!item.selling_plan_allocation;
            var hasAddonChild = false;
            if (!hasSellingPlan) {
              for (var j = 0; j < cart.items.length; j++) {
                var ci = cart.items[j];
                if (ci.properties && ci.properties._pdp_addon === 'true' && String(ci.properties._pdp_addon_of) === pid) {
                  hasAddonChild = true;
                  break;
                }
              }
            }
            if (hasSellingPlan || hasAddonChild) {
              updates[item.key] = 0;
            }
            continue;
          }

          // Bonus item linked to a PDP product
          if (props._bonus === 'true' && idSet.indexOf(String(props._bonus_of)) !== -1) {
            updates[item.key] = 0;
            continue;
          }
        }

        if (Object.keys(updates).length > 0) {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ updates: updates })
          });
        }
      } catch (e) {
        console.error('[ProductForm] Error clearing PDP cart items:', e);
      }
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (typeof CartDrawer !== 'undefined') {
          //new CartDrawer();
          window.cartDrawer.refresh();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }

        if (Shopify?.country != "US") {
          document.querySelectorAll("product-card-small[data-us='true']").forEach(item => {
            item.querySelector(".product-card-small--add-to-cart-button").innerHTML = "Unavailable";
            item.querySelector(".product-card-small--add-to-cart-button").disabled = true;
            item.querySelector(".product-card-small--add-to-cart-button").style.backgroundColor = 'gray';
          })
        }
      }));



      let product_drawer = document.getElementById('Product-Drawer'),
        search_drawer = document.getElementById('Search-Drawer');

      if (search_drawer && search_drawer.classList.contains('active')) {
        search_drawer.classList.remove('active');
      }
      if (product_drawer && product_drawer.contains(this)) {
        product_drawer.classList.remove('active');
        this.body.classList.remove('open-cc--product');
        if (document.getElementById('Cart-Drawer')) {
          this.body.classList.add('open-cc');
          document.getElementById('Cart-Drawer').classList.add('active');
        }
      } else if (document.getElementById('Cart-Drawer')) {
        this.body.classList.add('open-cc');
        document.getElementById('Cart-Drawer').classList.add('active');
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();

      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
    }
    connectedCallback() {
      this.setupObservers();
      this.setupToggle();
    }
    setupToggle() {
      const button = this.querySelector('.product-add-to-cart-sticky--inner'),
        content = this.querySelector('.product-add-to-cart-sticky--content');

      if (this.animations_enabled) {
        const tl = gsap.timeline({
          reversed: true,
          paused: true,
          onStart: () => {
            button.classList.add('sticky-open');
          },
          onReverseComplete: () => {
            button.classList.remove('sticky-open');
          }
        });

        tl
          .set(content, {
            display: 'block',
            height: 'auto'
          }, 'start')
          .from(content, {
            height: 0,
            duration: 0.25
          }, 'start+=0.001');

        button.addEventListener('click', function () {
          tl.reversed() ? tl.play() : tl.reverse();

          return false;
        });
      } else {
        button.addEventListener('click', function () {
          content.classList.toggle('active');
          return false;
        });
      }

    }
    setupObservers() {
      let _this = this,
        observer = new IntersectionObserver(function (entries) {
          entries.forEach((entry) => {
            if (entry.target === footer) {
              if (entry.intersectionRatio > 0) {
                _this.classList.remove('sticky--visible');
              } else if (entry.intersectionRatio == 0 && _this.formPassed) {
                _this.classList.add('sticky--visible');
              }
            }
            if (entry.target === form) {
              let boundingRect = form.getBoundingClientRect();

              if (entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top + boundingRect.height)) {
                _this.formPassed = true;
                _this.classList.add('sticky--visible');
              } else if (entry.intersectionRatio === 1) {
                _this.formPassed = false;
                _this.classList.remove('sticky--visible');
              }
            }
          });
        }, {
          threshold: [0, 1]
        }),
        form = document.getElementById(`product-form-${this.dataset.section}`),
        footer = document.getElementById('footer');
      _this.formPassed = false;
      observer.observe(form);
      observer.observe(footer);
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

/**
 *  @class
 *  @function ProductSidePanelLinks
 */
if (!customElements.get('side-panel-links')) {
  class ProductSidePanelLinks extends HTMLElement {
    constructor() {
      super();
      this.links = this.querySelectorAll('button');
      this.drawer = document.getElementById('Product-Information-Drawer');
      this.buttons = this.drawer.querySelector('.side-panel-content--tabs');
      this.panels = this.drawer.querySelector('.side-panel-content--inner').querySelectorAll('.side-panel-content--tab-panel');
      this.body = document.body;
    }
    connectedCallback() {
      this.setupObservers();
    }
    disconnectedCallback() {

    }
    setupObservers() {
      this.links.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.body.classList.add('open-cc');
          this.buttons.toggleActiveClass(i);
          this.drawer.classList.add('active');
        });
      });
    }
  }

  customElements.define('side-panel-links', ProductSidePanelLinks);
}

document.addEventListener("DOMContentLoaded", function() {
  // Function to remove an element from the document
  function removeElementsByClass(className) {
    const elements = document.getElementsByClassName(className);
    while (elements.length > 0) {
      elements[0].parentNode.removeChild(elements[0]);
    }
  }

  // Get the screen width
  const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

  // Set the breakpoint for mobile screens (e.g., 768px)
  const breakpoint = 768;

  // Remove .mobile-only elements from desktop screens
  if (screenWidth > breakpoint) {
    removeElementsByClass('mobile-only');
  }

  // Remove .desktop-only elements from mobile screens
  else {
    removeElementsByClass('desktop-only');
  }
});

(function () {
  function setButtonsForKey(key, showIndex) {
    if (!key) return;

    const btn1s = document.querySelectorAll(
      `.bundle-btn--1[data-bundle-key="${CSS.escape(key)}"]`
    );
    const btn2s = document.querySelectorAll(
      `.bundle-btn--2[data-bundle-key="${CSS.escape(key)}"]`
    );

    if (btn1s.length) btn1s.forEach((b) => (b.style.display = showIndex === 1 ? "" : "none"));
    if (btn2s.length) btn2s.forEach((b) => (b.style.display = showIndex === 2 ? "" : "none"));
  }

  function setPricesForKey(key, showIndex) {
    if (!key) return;

    // price wrapper(s) for this section key
    const priceWraps = document.querySelectorAll(
      `[data-bundle-price][data-bundle-key="${CSS.escape(key)}"]`
    );
    if (!priceWraps.length) return;

    priceWraps.forEach((wrap) => {
      const regular = wrap.querySelector(".regular-price");
      const bundle = wrap.querySelector(".bundle-price");
      if (!regular || !bundle) return;

      if (showIndex === 1) {
        regular.style.display = "";
        bundle.style.display = "none";
      } else {
        regular.style.display = "none";
        bundle.style.display = "";
      }
    });
  }

  function updateScope(scope) {
    if (!scope) return;

    const key = scope.getAttribute("data-bundle-key");
    if (!key) return;

    const radio1 = scope.querySelector('input[type="radio"][data-bundle-radio="1"]');
    const radio2 = scope.querySelector('input[type="radio"][data-bundle-radio="2"]');
    if (!radio1 || !radio2) return;

    // Default state
    if (!radio1.checked && !radio2.checked) radio1.checked = true;

    const showIndex = radio1.checked ? 1 : 2;

    setButtonsForKey(key, showIndex);
    setPricesForKey(key, showIndex);
  }

  function initAll() {
    document.querySelectorAll(".thb-product-detail [data-bundle-scope]").forEach((scope) => {
      updateScope(scope);

      if (!scope.__bundleBound) {
        scope.__bundleBound = true;

        scope.addEventListener("change", (e) => {
          if (!e.target.matches('input[type="radio"]')) return;
          updateScope(scope);
        });

        scope.addEventListener("click", () => {
          requestAnimationFrame(() => updateScope(scope));
        });
      }
    });
  }

  document.addEventListener("DOMContentLoaded", initAll);

  const mo = new MutationObserver(initAll);
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();



document.addEventListener("DOMContentLoaded", function () {
  // For each widget/section on the page
  document.querySelectorAll(".product-information--inner").forEach(function (root, widgetIndex) {

    // Radios inside this widget; reassign a unique name so groups don't conflict
    const radios = root.querySelectorAll('input[type="radio"][id^="radio"]');
    radios.forEach(function (r) {
      r.name = "bundle-" + widgetIndex; // isolate radio groups per widget
    });

    // Text blocks and cart buttons INSIDE this widget only
    const bundleTexts = root.querySelectorAll(".bundle-text-main > div");
    const bundles = [
      root.querySelector('[id="bundle-cart-btn1"]'),
      root.querySelector('[id="bundle-cart-btn2"]'),
      root.querySelector('[id="bundle-cart-btn3"]')
    ].filter(Boolean); // drop nulls if some aren't present

    // Show the corresponding bundle text and cart area for this widget
    function showBundleTextAndCart(id) {
      // Swap texts
      bundleTexts.forEach(function (el) {
        if (el.classList.contains("bundle-text" + id)) {
          el.style.display = "block";
        } else {
          el.style.display = "none";
        }
      });

      // Swap cart areas (btn1/btn2/btn3)
      bundles.forEach(function (btn, index) {
        if (!btn) return;
        btn.style.display = (index === id - 1) ? "block" : "none";
      });

      // Ensure the matching radio is checked (inside this widget)
      const radioToCheck = root.querySelector('#radio' + id);
      if (radioToCheck) radioToCheck.checked = true;
    }

    // Default to option 2 for this widget (adjust if you need a different default)
    showBundleTextAndCart(2);

    // Listen to radio changes (inside this widget only)
    radios.forEach(function (radio) {
      radio.addEventListener("change", function (e) {
        const selectedId = parseInt(e.target.id.replace("radio", ""), 10);
        showBundleTextAndCart(selectedId);
      });
    });

    // Make label clicks switch selection (labels have .bundle-type next to the radio)
    root.querySelectorAll(".bundle-type").forEach(function (labelEl) {
      labelEl.addEventListener("click", function () {
        const input = labelEl.previousElementSibling;
        if (input && input.type === "radio") {
          input.checked = true;
          const selectedId = parseInt(input.id.replace("radio", ""), 10);
          showBundleTextAndCart(selectedId);
        }
      });
    });
  });
});








